import React, { createContext, useContext, useState } from 'react';
import { pricingConfig } from '../data/pricing';
import type { BundleId } from '../data/pricing';
type SystemSelection = {
  selectedId: BundleId;
  setSelectedId: (id: BundleId) => void;
};
const SystemSelectionContext = createContext<SystemSelection | null>(null);

/** Shares the currently selected M1 PRO system between the selector and the sticky mobile buy bar. */
export function SystemSelectionProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [selectedId, setSelectedId] = useState<BundleId>(pricingConfig.defaultBundle);
  return <SystemSelectionContext.Provider value={{
    selectedId,
    setSelectedId
  }} data-id="element-979" data-mp="3orx04ig1mjrd">{children}</SystemSelectionContext.Provider>;
}
export function useSystemSelection() {
  const ctx = useContext(SystemSelectionContext);
  if (!ctx) throw new Error('useSystemSelection must be used inside SystemSelectionProvider');
  return ctx;
}